import {Endpoints} from '../../globals/api/endpoints';

export class TagEndpoints extends Endpoints {

  public static readonly TAGS = TagEndpoints.VIEWER + '/tag';
  public static readonly TAGS_FOR_PUBLISHED_VERSIONS = TagEndpoints.VIEWER + '/tags';
  public static readonly TAG = TagEndpoints.TAGS + '/' + TagEndpoints.TAG_ID;
}
